import { css } from 'styled-components';

export default css`
  padding: 0;
  height: 100px;
  overflow: auto;
  flex-grow: 1;
  .driver-instructions-value {
    font-family: 'Work Sans';
    white-space: pre-wrap;
  }
`;
